export const COUNTRY_USA_CUR = 458753;
export const COUNTRY_CANADA_CUR = 458753;
export const COUNTRY_AUSTRALIA_CUR = 458753;
export const COUNTRY_UAE_CUR = 458753;
export const COUNTRY_SINGAPORE_CUR = 458753;
export const COUNTRY_UK_CUR = 458753;
export const COUNTRY_HONGKONG_CUR = 458753;
